import React from 'react';

const Skeleton = ({ className = '', ...props }) => (
  <div
    className={`animate-pulse bg-gradient-to-r from-[#2a1a4d] via-[#6A3683]/40 to-[#2a1a4d] rounded ${className}`}
    {...props}
  />
);

export default Skeleton; 